import PropTypes from "prop-types";
import styles from "./ListingPage.css";
import addFaceAndBodyCarousel from "./addFaceAndBodyCarousel";
import addAdvert from "./addAdvert";
import getFocusTileIndex from "./getFocusTileIndex";
import mapProductsToProductTiles from "./mapProductsToProductTiles";

const ListingPage = ({
  isInitialPage,
  page: { products, pageNumber },
  focusFirstTile,
  focusLastTile,
  advert,
  faceAndBodyCarousel,
  dealBannerEnabled,
  dealBannerShownAsDiscount
}) => {
  const focusTileIndex = getFocusTileIndex({
    focusFirstTile,
    focusLastTile,
    products
  });

  let items = mapProductsToProductTiles({
    products,
    pageNumber,
    focusTileIndex,
    isInitialPage,
    dealBannerEnabled,
    dealBannerShownAsDiscount
  });

  let adPosition = null;

  ({ adPosition, items } = addAdvert({
    advert,
    items
  }));
  items = addFaceAndBodyCarousel({
    faceAndBodyCarousel,
    items,
    adPosition
  });

  return (
    <section className={styles.listingPage} data-auto-id={pageNumber}>
      {items}
    </section>
  );
};

ListingPage.propTypes = {
  isInitialPage: PropTypes.bool.isRequired,
  page: PropTypes.shape({
    products: PropTypes.arrayOf(PropTypes.object).isRequired,
    pageNumber: PropTypes.number
  }),
  focusFirstTile: PropTypes.bool.isRequired,
  focusLastTile: PropTypes.bool.isRequired,
  advert: PropTypes.func,
  faceAndBodyCarousel: PropTypes.func,
  dealBannerEnabled: PropTypes.bool.isRequired,
  dealBannerShownAsDiscount: PropTypes.bool.isRequired
};

export default ListingPage;
